/* tslint:disable */
/* eslint-disable */

export interface ILazyFunction<T> {
	(): T;
	isValueCreated?: boolean;
}

export class Lazy {
	public static singleton<T>(ctor: (new (arg?: any) => T), arg?: any): ILazyFunction<T> {
		let instance: any = null;

		let fn: ILazyFunction<T> = () => {
			if (instance === null) {
				instance = new ctor(arg);
				fn.isValueCreated = true;
			}
			return instance;
		};

		return fn;
	}

	public static fn<T>(func: () => T): () => T {
		let instance: any = null;
		return () => {
			if (instance === null) {
				instance = func();
			}
			return instance;
		};
	}

	public static memento<T extends Function>(func: T, getCachingKey: (...args: ArgTypes<T>) => string | number): T {
		let cache: any = {};
		let fn: any = function (...args: ArgTypes<T>) {
			let key = getCachingKey(...args);
			if (key in cache) {
				return cache[key];
			} else {
				return cache[key] = func.apply(this, args);
			}
		}
		return fn;
	}
}

type ArgTypes<T> = T extends (...args: infer A) => unknown ? A : []